module.exports = __webpack_public_path__ + "img/feedback7.ebbe5c40.svg";